import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    OnInit,
    ChangeDetectionStrategy,
    inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QueryObserverResult } from '@tanstack/query-core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { Country } from '../../models/location/country';
import { LocationDataService } from '../../services/location-data.service';
import { VirtualizationSettings } from '@progress/kendo-angular-dropdowns';

//<!-- FormGroup consumer -->
//<div formGroupName="common">
//    <app-countries-filter formControlName="countries"></app-countries-filter>
//</div>

//<!-- ngModel consumer -->
//<app-countries-filter [(ngModel)]="selectedCountries"></app-countries-filter>

@Component({
    selector: 'app-countries-filter',
    templateUrl: './countries-filter.component.html',
    styleUrls: ['./countries-filter.component.scss'],
    imports: [AsyncPipe, LabelModule, DropDownsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CountriesFilterComponent),
            multi: true,
        },
    ],
})
export class CountriesFilterComponent implements ControlValueAccessor, OnInit {
    private locationDataService = inject(LocationDataService);
    private cdr = inject(ChangeDetectorRef);

    public countriesQueryResults$?: Observable<
        QueryObserverResult<Country[], Error>
    >;

    public isDisabled: boolean = false;
    public value: string[] = [];
    public virtual: VirtualizationSettings = { itemHeight: 28 };

    private onChange: (value: string[]) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: string[]): void {
        this.value = value ?? [];
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    handleValueChange(value: string[]): void {
        this.value = value;
        this.onChange(value);
    }

    handleBlur(): void {
        this.onTouched();
    }

    ngOnInit(): void {
        this.countriesQueryResults$ =
            this.locationDataService.getCountries().result$;
    }
}
